export default {

    // TODO: Defer to the correct HTTP method function
    async call(path, queryString, callback, method = 'get', expects = 'json') {
        await axios.get('/api/call?path=' + path + '&method=' + method + '&expects=' + expects + '&' + queryString).then(response => {
            return callback(response.data);
        }).catch(error => {
            this.throwError(error);
        });
    },

    async get(path, queryString, callback, expects = 'json') {
        await axios.get('/api/call?path=' + path + '&method=get&expects=' + expects + '&' + queryString).then(response => {
            return callback(response.data);
        }).catch(error => {
            this.throwError(error);
        });
    },

    // TODO: Use axios POST method and move query string data to post body
    async post(path, queryString, callback, method = 'post', expects = 'json') {
        await axios.get('/api/call?path=' + path + '&method=' + method + '&expects=' + expects + '&' + queryString).then(response => {
            return callback(response.data);
        }).catch(error => {
            this.throwError(error);
        });
    },

    async patch(path, queryString, callback, expects = 'json') {
        return this.post(path, queryString, callback, 'patch', expects);
    },

    async put(path, queryString, callback, expects = 'json') {
        return this.post(path, queryString, callback, 'put', expects);
    },

    async delete(path, queryString, callback, expects = 'json') {
        return this.post(path, queryString, callback, 'delete', expects);
    },

    throwError(error = '', node = null) {
        if (node) {
            node.innerHTML = '';
        }

        if (error.length === 0) {
            error = 'Unknown error: Could not retrieve data from the API.';
        }

        flash(error, 'error');

        return error;
    },

    throwNoResponseError() {
        this.throwError('No response received from the API.');
    }

};
